import { ComponentsManager, Component, EventBus } from '../core/smpl-components.js'

import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

class ScrollReveal {
	constructor(options) {
		this.options = {
			selector: '[data-scroll-reveal]',
			revealDelay: 0.1,
			scroller: null, // default to `window` if no custom scroller is provided
			seqRevealDelay: 0.1, // default delay for sequential reveals
			initialRevealOnLoad: true,
			...options,
		}

		this.selector = this.options.selector
		this.scroller = this.options.scroller

		this.init()
	}
	init() {
		this.cleanup()

		const targets = gsap.utils.toArray(this.selector)
		if (!targets.length) return

		console.log(targets)

		this.batch = ScrollTrigger.batch(targets, {
			scroller: this.scroller,
			start: 'top 85%',
			once: true, // change to false if you want repeatable reveals
			// markers: true, // for debugging purposes, remove in production
			onEnter: (elements) => {
				console.log('Revealing elements:', elements)
				const { revealDelay, seqRevealDelay } = this.options
				const hasSequence = elements.length > 1

				elements.forEach((el, i) => {
					const delay = revealDelay + (hasSequence ? seqRevealDelay * i : 0)
					gsap.delayedCall(delay, () => el.classList.add('do-reveal'))
				})

				// Advanced: Group by rows for grid-like sequential reveals
				// const rows = {}
				// elements.forEach((el) => {
				// 	const groupingFactor = 20
				// 	const top =
				// 		Math.round(el.getBoundingClientRect().top / groupingFactor) *
				// 		groupingFactor

				// 	if (!rows[top]) rows[top] = []
				// 	rows[top].push(el)
				// })

				// const sortedTops = Object.keys(rows).sort((a, b) => a - b)
				// sortedTops.forEach((top, rowIndex) => {
				// 	const row = rows[top]
				// 	row.forEach((el, colIndex) => {
				// 		const delay =
				// 			revealDelay +
				// 			seqRevealDelay * rowIndex +
				// 			seqRevealDelay * 1 * colIndex // 0.5 is a factor for within-row stagger, adjust as needed
				// 		gsap.delayedCall(delay, () => el.classList.add('do-reveal'))
				// 	})
				// })
			},
			onLeaveBack: (elements) => {},
		})

		if (this.options.initialRevealOnLoad) {
			let initialRevealDone = false

			const runInitialRevealOnce = () => {
				if (initialRevealDone) return
				initialRevealDone = true
				this.revealVisibleElements(targets)
			}

			requestAnimationFrame(() => {
				if (window.scrollY > 50) {
					runInitialRevealOnce()
				} else {
				}
			})

			// add an extra reveal for mobile devices
			setTimeout(() => {
				if (window.scrollY > 50) {
					runInitialRevealOnce()
				}
			}, 250)
		}
	}
	refresh() {
		ScrollTrigger.refresh()
	}
	revealVisibleElements(cachedTargets) {
		console.log('Revealing visible elements on refresh/load')
		const elements = cachedTargets || gsap.utils.toArray(this.selector)
		if (!elements.length) return

		const viewportHeight = this.scroller ? this.scroller.clientHeight : window.innerHeight
		const scrollerTop = this.scroller ? this.scroller.getBoundingClientRect().top : 0

		const toReveal = []

		for (let i = 0; i < elements.length; i++) {
			const el = elements[i]
			if (el.classList.contains('do-reveal')) continue

			const top = el.getBoundingClientRect().top - scrollerTop
			if (top <= viewportHeight) {
				toReveal.push(el)
			}
		}

		if (!toReveal.length) return

		// Batch DOM writes
		toReveal.forEach((el) => el.classList.add('sr-no-transition', 'do-reveal'))
		requestAnimationFrame(() => {
			toReveal.forEach((el) => el.classList.remove('sr-no-transition'))
		})
	}
	cleanup() {
		if (this.batch) {
			this.batch.forEach((trigger) => trigger.kill())
			this.batch = null
		}
	}

	destroy() {
		this.cleanup()
	}
}

// -------------------------------------------------------------------------------- //
export default class extends Component {
	prepare() {
		console.log('Preparing ScrollReveal component')
		this.bndOnContentRefresh = this.onContentRefresh.bind(this)
		this.bndOnContentReplace = this.onContentReplace.bind(this)
		EventBus.on('swup:content:replace', this.bndOnContentReplace)
		EventBus.on('page:resize', this.bndOnContentRefresh)

		// Initialize ScrollReveal for the main page

		// console.log('scroll-reveal component prepared')
		// this.bndOnContentReplace = this.onContentReplace.bind(this)

		// EventBus.off('overlay:open', this.bndOnOverlayOpen)
		// EventBus.off('overlay:close', this.bndOnOverlayClose)
		// EventBus.on('swup:content:replace', this.bndOnContentReplace)
		// this.scrollReveal = new ScrollReveal({})

		//
	}
	mount() {
		this.scrollReveal = new ScrollReveal({ seqRevealDelay: 0.2 })
	}
	unmount() {
		if (this.scrollReveal) {
			this.scrollReveal.destroy()
		}
		if (this.overlayScrollReveal) {
			this.overlayScrollReveal.destroy()
		}

		EventBus.off('swup:content:replace', this.bndOnContentReplace)
		EventBus.off('page:resize', this.bndOnContentRefresh)
	}
	//
	onContentRefresh() {
		const self = this
		if (this.scrollReveal) {
			self.scrollReveal.refresh()
		}
	}
	onContentReplace() {
		if (this.overlayScrollReveal) {
			this.overlayScrollReveal.destroy()
		}
		// added a little timeout, that fixed the issue with the scroll reveal not working on some elements after page transition
		// mostly happened to the image and text on the about page.
		setTimeout(() => {
			if (this.scrollReveal) {
				this.scrollReveal.init()
			}
		}, 1)
	}
}
